import React from 'react';
import { Typography } from '@mui/material';

const Voting = () => (
  <>
    <Typography variant="h6" gutterBottom>
      Voting
    </Typography>
    <Typography variant="body2">
      Participate in alliance votes and view the results of past polls.
    </Typography>
  </>
);

export default Voting;
